// Manual TypeScript enum bindings for Rust enums
// CAUTION: Keep these in sync with /src/odin/rust/shared_sql/src/enums/mod.rs
// These numeric values must exactly match the Rust enum discriminants

export enum TransactionType {
  Invoice = 1,
  WorkOrder = 2,
  PurchaseOrder = 3,
  Afe = 4,
}

export enum TransactionStatus {
  Pending = 1,
  Redeemed = 2,
  Cancelled = 3,
}

export enum CommitmentType {
  WorkOrder = 1,
  PurchaseOrder = 2,
}

export enum TransactionApprovalType {
  Assignee = 1,
  Step = 2,
}

export enum DecisionType {
  Pending = 0,
  Approved = 1,
  Rejected = 2,
}

export enum RedemptionType {
  Redeem = 1,
  Cancel = 2,
}
